import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;}.b{fill:#0e204d;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H20V20H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M10.918,9.745l4.109-4.109L16.2,6.81l-4.109,4.109L16.2,15.027,15.027,16.2l-4.109-4.109L6.81,16.2,5.636,15.027l4.109-4.109L5.636,6.81,6.81,5.636Z",
			transform: "translate(-0.918 -0.918)"
		})
	]
});
export default SvgClose;
